import { gql } from '@apollo/client';

export const fetchTemplateMessageChannel = gql`
  query fetchTemplateMessageChannel($templateId: Long!) {
    templateAndContent(id: $templateId) {
      ... on TemplateAndContent {
        id: templateId
        messageType {
          id
          name
          messageChannel {
            channelType
            id
            messageMedium
          }
        }
      }
    }
  }
`;
